import { useQuery } from "@tanstack/react-query";
import { useRef } from "react";

import { CATEGORY_CACHE_KEYS } from "./keys";

import { CategoryRepository } from "@/repositories/category";

export const useGetAllCategories = () => {
  const categoryRepository = useRef(new CategoryRepository());

  return useQuery({
    queryKey: CATEGORY_CACHE_KEYS.LIST,
    queryFn: async () => {
      return await categoryRepository.current.findAll();
    },
  });
};
